'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _composeInjections = require('../../injections/composeInjections');

var _composeInjections2 = _interopRequireDefault(_composeInjections);

var _baseThunkAction = require('../../injections/baseThunkAction');

var _baseThunkAction2 = _interopRequireDefault(_baseThunkAction);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function createThunkAction(type, target, serviceCall) {
  var payload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  console.warn('redux-recompose: createThunkAction is deprecated. Use fetch middleware instead.');
  return (0, _composeInjections2.default)((0, _baseThunkAction2.default)({
    type: type,
    target: target,
    serviceCall: serviceCall,
    payload: payload
  }));
}

exports.default = createThunkAction;